<template>
	<div 
		class="line-scale2" 
		:class="[theme, size, inline]">
			<div class="line"></div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="line"></div>
		</div>
</template>

<script>
export default {
	props: ['theme', 'size', 'inline']
}
</script>

<style>
@-webkit-keyframes line-scale2 {
	0%,to {
		-webkit-transform: scaley(1);
		transform: scaley(1)
	}

	50% {
		-webkit-transform: scaley(.4);
		transform: scaley(.4)
	}
}

@keyframes line-scale2 {
	0%,to {
		-webkit-transform: scaley(1);
		transform: scaley(1)
	}

	50% {
		-webkit-transform: scaley(.4);
		transform: scaley(.4)
	}
}
.line-scale2 > div:nth-child(1) {
	-webkit-animation: line-scale2 1s -.4s infinite cubic-bezier(.2,.68,.18,1.08);
	animation: line-scale2 1s -.4s infinite cubic-bezier(.2,.68,.18,1.08)
}

.line-scale2>div:nth-child(2) {
	-webkit-animation: line-scale2 1s -.3s infinite cubic-bezier(.2,.68,.18,1.08);
	animation: line-scale2 1s -.3s infinite cubic-bezier(.2,.68,.18,1.08)
}

.line-scale2>div:nth-child(3) {
	-webkit-animation: line-scale2 1s -.2s infinite cubic-bezier(.2,.68,.18,1.08);
	animation: line-scale2 1s -.2s infinite cubic-bezier(.2,.68,.18,1.08)
}

.line-scale2>div:nth-child(4) {
	-webkit-animation: line-scale2 1s -.1s infinite cubic-bezier(.2,.68,.18,1.08);
	animation: line-scale2 1s -.1s infinite cubic-bezier(.2,.68,.18,1.08)
}

.line-scale2>div:nth-child(5) {
	-webkit-animation: line-scale2 1s 0s infinite cubic-bezier(.2,.68,.18,1.08);
	animation: line-scale2 1s 0s infinite cubic-bezier(.2,.68,.18,1.08)
}

.line-scale2 > div {
	background-color: #fff;
	width: 3px;
	height: 35px;
	border-radius: 2px;
	margin: 0px;
	animation-fill-mode: both;
	display: inline-block;
}
.line-scale2 > div {
		background-color: #2b58ad;
		width: 3px;
		height: 25px;
		margin: 0px;
}
 .line-scale2 .line{
	background-color: #2b58ad !important;
}
.line-scale2.inline {
	display: inline;
}

/* .line-scale2.small .line {
	height: 20px;
	width: 2px;
	margin: 1px;
	margin-left: 3px;
} */

.line-scale2.small .line {
	height: 16px;
	width: 4px;
	margin: 0px;
	margin-left: 3px;
}

.line-scale2.mini .line {
	height: 12px;
	width: 4px;
	margin: 0px;
	margin-left: 3px;
}

.line-scale2.micro .line {
	height: 12px;
	width: 3px;
	margin: 0px;
	margin-left: 3px;
}

.line-scale2.light .line {
	background-color: #ffffff !important;
}

.line-scale2.dark .line {
	background-color: #2b58ad !important;
}

.line-scale2.gray .line {
	background-color: #cccccc !important;
}

.line-scale2.black .line {
	background-color: #333 !important;
}
</style>
